import { Component, inject } from '@angular/core';
import { NavigationService } from '@app/@services/navigation/navigation.service';
import { SessionPopupHelperService } from '@shared/session-expired/business/helpers/session-popup-helper.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-session-expired-popup',
  templateUrl: './session-expired-popup.component.html',
  standalone: true,
  imports: [TranslateModule],
})
export class SessionExpiredPopupComponent {
  private readonly navigationService = inject(NavigationService);

  private readonly sessionPopupHelperService = inject(SessionPopupHelperService);

  reconnect() {
    this.sessionPopupHelperService.closeModal();
    this.navigationService.navigate(['login']);
  }
}
